var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3559_538)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#007EBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7778 31.6666H27.7552V23.1121C27.7552 20.7666 26.864 19.4559 25.0076 19.4559C22.9881 19.4559 21.933 20.8199 21.933 23.1121V31.6666H17.0926V15.3703H21.933V17.5654C21.933 17.5654 23.3883 14.8724 26.8465 14.8724C30.3031 14.8724 32.7778 16.9832 32.7778 21.3488V31.6666ZM11.3181 13.2364C9.66935 13.2364 8.33334 11.89 8.33334 10.2293C8.33334 8.56866 9.66935 7.22217 11.3181 7.22217C12.9668 7.22217 14.302 8.56866 14.302 10.2293C14.302 11.89 12.9668 13.2364 11.3181 13.2364ZM8.81873 31.6666H13.866V15.3703H8.81873V31.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3559_538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedIn_Icon.151f265d74832606d96fa827e4ebfc33.svg";
export { ForwardRef as ReactComponent };